import { useQuery } from "@tanstack/react-query";

const ONE_MONTH = 30 * 24 * 60 * 60 * 1000;

export function usePublicFetch(key, fetcher, params = {}, options = {}) {
  return useQuery({
    queryKey: ["public", key, params],
    queryFn: () => fetcher(params),
    staleTime: ONE_MONTH, // 1 month fresh
    cacheTime: ONE_MONTH, // 1 month memory cache
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...options,
  });
}
